export const defaultStyle = {
  fillcolor: "orange",
  fillopacity: 0.6,
  strokecolor: "orange",
  strokewidth: 5,
  opacity: 0.6,
};

export default {
  FILL_COLOR: "",
  STROKE_COLOR: "",
  STROKE_WIDTH: 1,

  // labels
  LABEL_BACKGROUND: "#36B37E",

  RELATION_BACKGROUND: "#fff",

  // label on image
  SHOW_LABEL_FILL: "white",
  SHOW_LABEL_BACKGROUND: "black",

  // when region gets highlighted styling
  HIGHLIGHTED_STROKE_COLOR: "red",
  HIGHLIGHTED_STROKE_WIDTH: 2,
  HIGHLIGHTED_CSS_BORDER: "1px dashed #00aeff",

  // cursors
  DEFAULT_CURSOR: "default",
  CHOOSE_CURSOR: "pointer",
  POINTER_CURSOR: "pointer",
  MOVE_CURSOR: "move",
  RELATION_MODE_CURSOR: "crosshair",

  // images
  BRIGHTNESS_VALUE: 100,
  BRIGHTNESS_MAX: 400,

  CONTRAST_VALUE: 100,
  CONTRAST_MAX: 400,
};
